module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-cart@3x.53f5af8b.jpg";